/**
 * @flow
 * @relayHash 5762119825520853b552c5ad2c2690c7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type JobStatus = "A_1" | "A_10" | "A_2" | "A_3" | "A_4" | "A_5" | "A_6" | "A_7" | "A_8" | "A_9" | "%future added value";
export type SignJobContractInput = {|
  jobId: string,
  contractDate?: ?any,
  clientMutationId?: ?string,
|};
export type SignJobContractMutationVariables = {|
  input: SignJobContractInput
|};
export type SignJobContractMutationResponse = {|
  +signJobContract: ?{|
    +job: ?{|
      +id: string,
      +status: JobStatus,
      +contract: ?{|
        +id: string,
        +contractId: ?number,
        +dateSignedByOrganization: ?any,
        +dateSignedByContractor: ?any,
        +signedPdfByContractorUrl: ?string,
        +signedPdfByOrganizationUrl: ?string,
        +finalizedPdfUrl: ?string,
        +template: ?{|
          +name: string
        |},
      |},
    |},
    +emailSent: ?boolean,
  |}
|};
export type SignJobContractMutation = {|
  variables: SignJobContractMutationVariables,
  response: SignJobContractMutationResponse,
|};
*/


/*
mutation SignJobContractMutation(
  $input: SignJobContractInput!
) {
  signJobContract(input: $input) {
    job {
      id
      status
      contract {
        id
        contractId
        dateSignedByOrganization
        dateSignedByContractor
        signedPdfByContractorUrl
        signedPdfByOrganizationUrl
        finalizedPdfUrl
        template {
          name
          id
        }
      }
    }
    emailSent
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SignJobContractInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contractId",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dateSignedByOrganization",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dateSignedByContractor",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "signedPdfByContractorUrl",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "signedPdfByOrganizationUrl",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "finalizedPdfUrl",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailSent",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SignJobContractMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "signJobContract",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SignJobContractPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "job",
            "storageKey": null,
            "args": null,
            "concreteType": "JobNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contract",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "template",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractTemplateNode",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SignJobContractMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "signJobContract",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SignJobContractPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "job",
            "storageKey": null,
            "args": null,
            "concreteType": "JobNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contract",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "template",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ContractTemplateNode",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "SignJobContractMutation",
    "id": null,
    "text": "mutation SignJobContractMutation(\n  $input: SignJobContractInput!\n) {\n  signJobContract(input: $input) {\n    job {\n      id\n      status\n      contract {\n        id\n        contractId\n        dateSignedByOrganization\n        dateSignedByContractor\n        signedPdfByContractorUrl\n        signedPdfByOrganizationUrl\n        finalizedPdfUrl\n        template {\n          name\n          id\n        }\n      }\n    }\n    emailSent\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'abf0d71b117c76f8e84e5287bd1393e3';
module.exports = node;
